export enum SyncStatus {
  cancelled = 'cancelled',
  cancelling = 'cancelling',
  completed = 'completed',
  failed = 'failed',
  preparing = 'preparing',
  savingInspection = 'savingInspection',
  uploadingFiles = 'uploadingFiles',
}
